export default __webpack_public_path__ + "static/media/matichon.bdae4ab3.svg";